import React from 'react';
import { admins } from 'types';

import DialogConfirm from 'components/dialog/dialog-confirm';
import { Row } from 'components/layout/layout';
import { TDialogWrapperComponent } from 'components/dialog/index.types';
import useAdminsUnblock from '../hooks/use-admins-unblock';
import { Body1 } from 'components/typography';

const UnblockDialog = ({
    setIsDialogOpen,
    isDialogOpen,
    asyncStatesHandlers,
    data,
}: { data: admins.TAdmins } & TDialogWrapperComponent) => {
    const [onAdminUnblock] = useAdminsUnblock(asyncStatesHandlers);

    return (
        <DialogConfirm<admins.TAdmins>
            isDialogOpen={data && isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Unblock admin'}
            onOk={async () => {
                if (!data.id) {
                    console.error('No ID');
                    return;
                }
                try {
                    await onAdminUnblock({ id: data.id });
                } catch (e) {}
            }}
        >
            <Row>
                <Body1>Confirm unblocking of admin with an email: {data.email}</Body1>
            </Row>
        </DialogConfirm>
    );
};

export default UnblockDialog;
